import { DateTime } from "luxon";

/** Date-only parsing: never delegate a historical French date to Date. */
export function formatAnimalBirthDate(value: string | null | undefined): string {
  if (!value || value.length !== 10) return "-";
  for (const format of ["yyyy-MM-dd", "dd/MM/yyyy"]) {
    const date = DateTime.fromFormat(value, format, { locale: "fr", zone: "UTC" });
    if (date.isValid && date.toFormat(format) === value) return date.toFormat("dd/MM/yyyy");
  }
  return "-";
}
